import React from 'react'
import PropTypes from 'prop-types'

import CategoryListingComponent from '../../listing/category'

import style from './style'

const CategoryListing = ({ categoryId }) => (
  <CategoryListingComponent id={categoryId} className={style('listing-with-content')} />
)
CategoryListing.propTypes = {
  categoryId: PropTypes.string.isRequired,
}
export default CategoryListing
